import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BottomSheetHostDirective } from './bottom-sheet-host.directive';
import { BottomSheetReturnType } from './bottom-sheet-return-type.enum';
import { BottomSheetService } from './bottom-sheet.service';

@Component({
  selector: 'prism-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss'],
})
export class BottomSheetComponent implements OnInit, AfterViewInit {

  private submitPressed$: Subject<void> = new Subject()

  private dragging = false;
  private startY = 0;
  private currentTranslate = 0;

  @ViewChild(BottomSheetHostDirective, { static: true }) sheetHost!: BottomSheetHostDirective;
  @ViewChild('sheet', { static: true }) sheetRef!: ElementRef<HTMLDivElement>;

  constructor(
    public bottomSheetService: BottomSheetService<any>,
  ) { }

  ngOnInit(): void {
    const component = this.sheetHost.viewContainerRef.createComponent(this.bottomSheetService.component);

    // Two @Inputs added to each child, accessible via:
    // @Input() submitPressed$!;
    // @Input() args!;
    component.instance.submitPressed$ = this.submitPressed$
    component.instance.args = this.bottomSheetService.args
  }

  ngAfterViewInit(): void {
    // Paint the sheet off-screen first, then animate it up on the next frame.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      this.bottomSheetService.show = true;
    }));
  }

  public submit(): void {
    if (this.bottomSheetService.submitButtonEnabled$.value) {
      this.submitPressed$.next()
    }
  }

  public secondary(): void {
    this.bottomSheetService.submit$.next({ value: null, type: BottomSheetReturnType.SECONDARY })
  }

  public close(): void {
    this.bottomSheetService.closeBottomSheet()
  }

  public onBackdrop(): void {
    if (this.bottomSheetService.closeButtonEnabled$.value) {
      this.close()
    }
  }

  @HostListener('document:keydown', ['$event'])
  public handleKeyPress(event: KeyboardEvent): void {
    if (event.key === "Escape" && this.bottomSheetService.closeButtonEnabled$.value) {
      this.close()
    }
  }

  public startDrag(event: PointerEvent): void {
    this.dragging = true;
    this.startY = event.clientY;
    this.currentTranslate = 0;
    this.sheetRef.nativeElement.style.transition = 'none';
    document.addEventListener('pointermove', this.onDrag);
    document.addEventListener('pointerup', this.stopDrag);
  }

  private onDrag = (event: PointerEvent): void => {
    if (!this.dragging) return;
    this.currentTranslate = Math.max(0, event.clientY - this.startY);
    this.sheetRef.nativeElement.style.transform = `translate(-50%, ${this.currentTranslate}px)`;
  };

  private stopDrag = (): void => {
    if (!this.dragging) return;
    this.dragging = false;
    document.removeEventListener('pointermove', this.onDrag);
    document.removeEventListener('pointerup', this.stopDrag);

    const sheet = this.sheetRef.nativeElement;
    sheet.style.transition = '';
    sheet.style.transform = '';

    if (this.currentTranslate > 120 && this.bottomSheetService.closeButtonEnabled$.value) {
      this.close();
    }
  };
}
